import Logo from "@/components/layouts/Logo";
import React, { ReactNode } from "react";

interface LogoHeaderProps {
    heading: string;
    children: ReactNode;
    id?: string;
}

const LogoHeader: React.FC<LogoHeaderProps> = ({ heading, children, id }) => {
    return (
        <div>
            <div className="brand-logo center mb-5 pb-4">
                <Logo id={id} />
            </div>
            <div className="nk-block-head">
                <div className="nk-block-head-content">
                    <h5 className="nk-block-title center pb-3" id={`${id}-page-heading`}>
                        {heading}
                    </h5>
                    <div className="nk-block-des">
                        <p className="center">{children}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LogoHeader;
